import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/home-photo.png";
import homeImg from "../../Assets/favrhoodapp.png";
import Tilt from "react-parallax-tilt";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import useInViewOnce from "../../hooks/useInViewOnce";



function Home2() {

  const { ref: innovationRef, inView: innovationInView } = useInViewOnce({
    threshold: 0.2,
    once: false,
  });

  const { ref: entrepreneurshipRef, inView: entrepreneurshipInView } = useInViewOnce({
    threshold: 0.2,
    once: false,
  });

  const { ref: socialContributionRef, inView: socialContributionInView } = useInViewOnce({
    threshold: 0.2,
    once: false,
  });

  const handleClick = () => {
    window.open("https://www.favrhood.com/", "_blank", "noopener,noreferrer");
  };


  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 className="home-about-title">
              EMPOWERING. <span className="purple"> INNOVATING. </span> EDUCATING
            </h1>
            <p className="home-about-body">
              At Choicest Fruit<span className="small-r-symbol">®</span>, we believe technology is not just
               about innovation, it’s about elevating people, strengthening communities, protecting our
                environment, and shaping a future where everyone can thrive. We empower youth, educators, 
                and organizations to move beyond simply using technology to creating it with purpose,
                 designing solutions that respond to real challenges in the communities they live in. 
                 Rooted in <b className="purple">localized innovation</b>, our approach enables young people to build for their 
                 own neighborhoods, while developing the confidence and skills to turn ideas into meaningful impact.            
              <br />
              <br />
              But innovation alone isn’t enough. We place equal emphasis on <b className="purple">storytelling</b>, helping participants 
              articulate not just what they create, but why it matters. This narrative power transforms projects 
              into movements and ideas into opportunities, resonating far beyond the classroom. Through hands-on 
              learning, mentorship, and real-world experiences—from peer collaboration across communities to 
              internships and project showcases—we create environments where people connect, inspire one another, and grow together.
              <br />
              <br />
             As a forward-thinking <b className="purple">social enterprise</b> and Community Technology & Innovation Lab, 
             we are reimagining how technology is developed, taught, and used to better serve people. We partner 
             with schools, cities, nonprofits, and organizations to design and implement solutions that are inclusive, 
             practical, and widely adopted. Whether through training programs, workforce development, ethical technology 
             guidance, or platforms like Favrhood, our goal remains the same: to create technology that reflects human values, 
             expands opportunity, and empowers communities to shape their future together.
               <br />
              <br />
              Join us in building a future where technology is a tool for empowerment, a catalyst for innovation, and a force for good in the world.
      
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <div className="policy-card home2-avatar-card">
              <Tilt className="home2-avatar-tilt" tiltMaxAngleX={8} tiltMaxAngleY={8}>
                <img src={myImg} className="img-fluid home2-avatar-img" alt="avatar" />
              </Tilt>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Fostering <span className="purple">innovation</span>, <span className="purple">entrepreneurship</span>, and <span className="purple"> social contribution </span></h1>
            <div
              className="foster-cards"
              role="list"
              aria-label="How Choicest Fruit fosters impact"
            >
              <div
                ref={innovationRef}
                className={`foster-card-wrap${innovationInView ? " is-seen" : ""}`}
                role="listitem"
                style={{ "--foster-delay": "0ms" }}
              >
                <Card className="foster-card">
                  <Card.Body>
                    <Card.Title className="foster-card-title">Innovation</Card.Title>
                    <Card.Text className="foster-card-text">
                      Choicest Fruit fosters <span className="purple">innovation</span> by giving learners the space, tools,
                      and guidance to identify real community challenges and design practical solutions — from idea to prototype
                      to showcase.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>

              <div
                ref={entrepreneurshipRef}
                className={`foster-card-wrap${entrepreneurshipInView ? " is-seen" : ""}`}
                role="listitem"
                style={{ "--foster-delay": "120ms" }}
              >
                <Card className="foster-card">
                  <Card.Body>
                    <Card.Title className="foster-card-title">Entrepreneurship</Card.Title>
                    <Card.Text className="foster-card-text">
                      We foster <span className="purple">entrepreneurship</span> by teaching participants how to validate ideas,
                      communicate value through storytelling, collaborate with mentors, and build pathways toward internships,
                      paid opportunities, and ventures.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>

              <div
                ref={socialContributionRef}
                className={`foster-card-wrap${socialContributionInView ? " is-seen" : ""}`}
                role="listitem"
                style={{ "--foster-delay": "240ms" }}
              >
                <Card className="foster-card">
                  <Card.Body>
                    <Card.Title className="foster-card-title">Social Contribution</Card.Title>
                    <Card.Text className="foster-card-text">
                      And we foster <span className="purple">social contribution</span> by centering ethics, accessibility, and
                      community voice — so technology is created with (not just for) the people it impacts.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <Button onClick={handleClick} className="custom-yellow-btn home2-cta-btn">
              Get Started with Favrhood
            </Button>

            <Row className="justify-content-center mt-4">
              <Col xs={12} sm={10} md={8} lg={6} className="text-center">
                <Tilt className="favrhood-tilt" tiltMaxAngleX={6} tiltMaxAngleY={6}>
                  <img
                    src={homeImg}
                    className="img-fluid favrhood-img"
                    alt="Favrhood app preview"
                  />
                </Tilt>
              </Col>
            </Row>
    
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
